import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import SheetHeader from "../../../components/ui/SheetHeader";
import Button from "../../../components/ui/Button";
import { Body, Question, Actions } from "./ConfirmSendModal.styles";

interface ConfirmSendModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// isOpen is always false in practice today: no caller in SaleTerminate/index.tsx
// ever sets it to true (the only reference to opening it is a commented-out
// //openModal(); inside an already-commented-out block), since the real send
// always happens automatically via the useEffect that watches sale.store.cellPhone.
// This is preserved exactly as-is, per docs/superpowers/specs/
// 2026-07-14-remaining-pages-modularizacao-design.md -- do not wire it up or
// remove it, that would be an unauthorized behavior change. BottomSheet renders
// nothing while `open` is false (its `mounted` state starts as `open` and only a
// transition to true schedules a mount), so this invariant holds unchanged.
export default function ConfirmSendModal({ isOpen, onClose, onConfirm }: ConfirmSendModalProps) {
  return (
    <BottomSheet open={isOpen} onClose={onClose}>
      <SheetHeader title="Confirmação" onClose={onClose} />
      <Body>
        <Question>Deseja enviar o pedido para o estabelecimento via WhatsApp ?</Question>
        <Actions>
          <Button variant="ghost" full onClick={onClose}>
            Não
          </Button>
          <Button
            variant="primary"
            full
            onClick={() => {
              onClose();
              onConfirm();
            }}
          >
            Sim
          </Button>
        </Actions>
      </Body>
    </BottomSheet>
  );
}
